import Chat from './components/Chat'
import * as chatActions from './actions'
import chatReducer from './reducers'
import chatSaga from './sagas'
import * as chatSelectors from './selectors'

export default Chat

export { chatActions, chatReducer, chatSelectors, chatSaga }
